<div id="map-container">
  <div id="map" class="map">
  
    <button mat-button [matMenuTriggerFor]="menu" 
    class="map-item map-type"
    title="{{mapService.mapstore.type.active}} (Map Layer)" 
    aria-label="Menu">
  <i class="material-icons">layers</i>
</button> 
<mat-menu #menu="matMenu">
  <button mat-menu-item (click)="setMapType('SatSM')" aria-label="Satellite/street map">Satellite/street map</button>
  <button mat-menu-item (click)="setMapType('SatM')" aria-label="Satellite map">Satellite map</button>
  <button mat-menu-item (click)="setMapType('SM')" aria-label="Street map">Street map</button>
  <button mat-menu-item (click)="setMapType('TM')" aria-label="Terrain map">Terrain map</button>
  <button mat-menu-item (click)="setMapType('OSM')" aria-label="OpenStreetMap">OpenStreetMap</button>
</mat-menu>

<button type="button"
      class="map-item map-reset"
      (click)="clearMap()"
      title="Clear Map"
      aria-label="Clear Map">
  <i class="material-icons">layers_clear</i>
</button>

<button type="button"
      class="map-item box-selection"
      (click)="toggleDraw()"
      aria-label="Draw bounding box"
      title="Draw bounding box">
  <img class="map-control" src="assets/images/box.png"/>
</button>

<button type="button"
      class="map-item map-clear"
      (click)="clearSearchPolygon()"
      aria-label="Remove Polygon"
      title="Remove Search Polygon">
  <i class="material-icons">clear</i>
</button>
<!--
<button type="button"
      class="map-item polygon-edit"
      ng-click="editPolygonDialog($event)"
      aria-label="Edit Polygon"
      title="Edit Polygon">
  <i class="material-icons">edit</i>
</button>

<button type="button"
      class="map-item polygon-copy"
      ng-click="copyPolygon()"
      ng-disabled="mapService.mapstore.aoi === undefined || mapService.mapstore.aoi.wkt === undefined"
      aria-label="Copy Polygon to Clipboard"
      title="Copy Polygon to Clipboard">
  <i class="material-icons">content_copy</i>
</button>
-->
  <a href="http://mapbox.com/about/maps" class="mapbox-logo" target="_blank">Mapbox</a>
  <div class="mapbox-attribution-container">
      <a href="https://www.mapbox.com/about/maps/" target="_blank">© Mapbox | </a>
      <a href="http://www.openstreetmap.org/copyright" target="_blank">© OpenStreetMap | </a>
      <a href="https://www.mapbox.com/map-feedback/" target="_blank"><strong>Improve this map</strong></a>
  </div>
</div>
</div>
